import { render, staticRenderFns } from "./CreateAppStoreChannel.vue?vue&type=template&id=682ff345&scoped=true"
import script from "./CreateAppStoreChannel.vue?vue&type=script&lang=js"
export * from "./CreateAppStoreChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateAppStoreChannel.vue?vue&type=style&index=0&id=682ff345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682ff345",
  null
  
)

export default component.exports